export const ja = {
  heroData: {
    title: "ヘリポートまでのアクセス",
    subtitle: "横浜のヘリポートへ、電車・お車・タクシーでお越しいただけます。アクセスしやすいロケーションです。",
    image: "https://readdy.ai/api/search-image?query=Modern%20helipad%20facility%20entrance%20with%20clean%20architectural%20design%2C%20warm%20sunset%20lighting%2C%20luxury%20transportation%20hub%2C%20deep%20navy%20sky%20gradient%2C%20professional%20and%20welcoming%20atmosphere%2C%20editorial%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=accesshero01&orientation=landscape",
  },
  accessInfo: {
    label: "ACCESS",
    title: "アクセス情報",
    address: { label: "所在地", value: "【住所情報は準備中です】" },
    methods: [
      { type: "train", title: "電車でお越しの場合", desc: "最寄り駅からタクシーまたは徒歩でお越しいただけます。詳細な道順は予約確定後にご案内いたします。" },
      { type: "car", title: "お車でお越しの場合", desc: "ヘリポート近隣に駐車場がありますが、台数に限りがあります。ご予約時にお車でのご来場をお申し出ください。" },
      { type: "taxi", title: "タクシーでお越しの場合", desc: "最寄り駅からタクシーで約5〜10分です。送迎サービスもオプションで承ります。" },
    ],
  },
  mapNote: {
    label: "MAP",
    title: "周辺マップ",
    description: "ヘリポート周辺のマップは準備中です。ご予約確定後、詳細なアクセスマップをお送りいたします。",
  },
  tipsData: {
    label: "TIPS",
    title: "アクセスのヒント",
    items: [
      "搭乗開始時刻の30分前にはご到着ください",
      "ヘリポートは屋外施設です。雨天時は傘をお持ちください",
      "駐車場は事前予約制です。利用を希望される場合は予約時にお申し出ください",
      "遅延される場合は、必ずお電話でご連絡ください",
      "ヘリポート周辺は住宅街です。近隣の住民の方々にご配慮ください",
    ],
  },
  finalCTA: {
    title: "アクセスの詳細は、\nご予約時にご案内いたします",
    subtitle: "ご不明な点があれば、お気軽にお問い合わせください",
    ctas: [{ label: "予約について問い合わせる", href: "/contact", type: "primary" }],
  },
};

export const en = {
  heroData: {
    title: "Getting to the Helipad",
    subtitle: "Our Yokohama helipad is easily accessible by train, car, or taxi.",
    image: "https://readdy.ai/api/search-image?query=Modern%20helipad%20facility%20entrance%20with%20clean%20architectural%20design%2C%20warm%20sunset%20lighting%2C%20luxury%20transportation%20hub%2C%20deep%20navy%20sky%20gradient%2C%20professional%20and%20welcoming%20atmosphere%2C%20editorial%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=accesshero01&orientation=landscape",
  },
  accessInfo: {
    label: "ACCESS",
    title: "Access Information",
    address: { label: "Address", value: "[Address details coming soon]" },
    methods: [
      { type: "train", title: "By Train", desc: "You can take a taxi or walk from the nearest station. Detailed directions will be provided after your reservation is confirmed." },
      { type: "car", title: "By Car", desc: "Parking is available near the helipad, but spaces are limited. Please let us know at the time of booking if you plan to drive." },
      { type: "taxi", title: "By Taxi", desc: "Approximately 5–10 minutes by taxi from the nearest station. A pick-up service is also available as an optional add-on." },
    ],
  },
  mapNote: {
    label: "MAP",
    title: "Area Map",
    description: "A map of the helipad area is being prepared. Detailed access information will be sent to you after your reservation is confirmed.",
  },
  tipsData: {
    label: "TIPS",
    title: "Access Tips",
    items: [
      "Please arrive at least 30 minutes before your scheduled boarding time.",
      "The helipad is an outdoor facility. Please bring an umbrella on rainy days.",
      "Parking is available by prior reservation. Please request this at the time of booking.",
      "If you are running late, please call us immediately.",
      "The helipad is located in a residential area. Please be considerate of local residents.",
    ],
  },
  finalCTA: {
    title: "Detailed access info will\nbe provided at booking",
    subtitle: "Feel free to contact us if you have any questions",
    ctas: [{ label: "Inquire About Booking", href: "/contact", type: "primary" }],
  },
};
